// Shared section wrapper for the redesigned pages -- one max width so the
// nav, hero and every section share the same left/right edges.
export const SECTION = 'mx-auto w-full max-w-7xl px-6 py-16 sm:py-24'
export const PAGE_WIDTH = 'mx-auto w-full max-w-7xl px-6'
